module.exports = __webpack_public_path__ + "theme-background.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/core/components/editor/styled/theme-background.jpg
// module id = 2608
// module chunks = 0